import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  executarOsSearchParameters: {
    NumAuto: "",
    dtInicio: "",
    dtFim: "",
    sqSituacao: "",
    NuTipoAcaoFiscal: "",
    NuFase: "",
    Identificador: "",
    MatriculaAuditor: "",
    nomeAuditor: "",
    nomeDiretor: "",
    codigoDiretor: "",
    situacaoProrroga: "",
    qtDiasProrroga: "",
  },
  filterButton: false,
  pathname: "",
  person: 1,
  diretor: 1,
  group: 1,
  timer: 1,
};

const executarOsSearchSlice = createSlice({
  name: "executarOsSearch",
  initialState,
  reducers: {
    salvarEstado(state, action) {
      state.executarOsSearchParameters = { ...action.payload };
    },
    estadoBotao(state, action) {
      state.filterButton = action.payload;
    },
    estadoPathname(state, action) {
      state.pathname = action.payload;
    },
    estadoisPerson(state, action) {
      state.person = action.payload;
    },
    estadoisDiretor(state, action) {
      state.diretor = action.payload;
    },
    estadoisGroup(state, action) {
      state.group = action.payload;
    },
    estadoisTimer(state, action) {
      state.timer = action.payload;
    },
    reset: () => initialState,
  },
});

export const executarOsSearchActions = executarOsSearchSlice.actions;

export default executarOsSearchSlice.reducer;
